module.exports = new __parcel__URL__("little_piece_of_home_cosmetic.771d9edb.png").toString();